import React from 'react'
import { TrendingCard, type TrendingLink } from '@/ui/components/Card/TrendingCard'
import { Header } from '@/ui/components/Header'

type TrendingCardData = {
  title: string
  icon?: string | null
  id?: string | null
  links: TrendingLink[]
}

export type TrendingNowProps = {
  label?: string | null
  title?: string | null
  description?: string | null
  trendingCards: TrendingCardData[]
  className?: string
}

export const TrendingNow: React.FC<TrendingNowProps> = ({
  label,
  title,
  description,
  trendingCards,
  className,
}) => {
  return (
    <div className={className || ''}>
      <Header label={label} title={title} description={description} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {trendingCards.map((trendingCard, index) => (
          <TrendingCard
            key={trendingCard.id || index}
            title={trendingCard.title}
            icon={trendingCard.icon}
            links={trendingCard.links}
            appearance="filled"
          />
        ))}
      </div>
    </div>
  )
}
